const Period = () => {
    

    const date = new Date();
    const hours = date.getHours();
    
    
    let period;
    let night;


    if ((hours >= 5 && hours < 9) || (hours >= 18 && hours < 21)) {
        period = '_dawn';
    } else if ((hours >= 0 && hours < 5) || (hours >= 21 && hours <= 23)) {
        period = '_night';
        night = true;
    } else {
        period = '_day';
    }

    return { period, night };
}

export default Period;

